import { Component, OnInit, Output, EventEmitter, Input, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-report-navigation',
  templateUrl: './report-navigation.component.html',
  styleUrls: ['./report-navigation.component.scss']
})
export class ReportNavigationComponent implements OnInit {

  //#region Inputs

  @Input() page: number;
  @Input() totalPages: number;
  @Input() pageSize: number;
  @Input() justifyContent: string;

  //#endregion

  //#region Outputs

  @Output() pageChanged: EventEmitter<number> = new EventEmitter<number>();

  //#endregion

  //#region Ctor

  constructor(private renderer: Renderer2) { }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
  }

  //#endregion

  registerInputKeyPressed(event): boolean {
    if (isNaN(event.key) === true &&
      event.which !== 13) {
      return false;
    }
    return true;
  }

  getPageInfo(): string {
    let msg = '';

    if (this.totalPages === 0) {
      msg = 'Nenhum registro encontrado';
    } else if (!this.totalPages) {
      msg = 'Carregando registros';
    } else {
      msg = `${this.page} de ${this.totalPages}`;
    }

    return msg;
  }

  //#region Events

  fisrt() {
    if (this.totalPages !== 0 && this.page !== 1) {
      this.page = 1;
      this.emitPageChange();
    }
  }

  back() {
    if ( this.totalPages !== 0 && this.page > 1) {
      this.page--;
      this.emitPageChange();
    }
  }

  next() {
    if (this.totalPages !== 0 && this.page < this.totalPages) {
      this.page++;
      this.emitPageChange();
    }
  }

  last() {
    if (this.totalPages !== 0 && this.page !== this.totalPages) {
      this.page = this.totalPages;
      this.emitPageChange();
    }
  }

  emitPageChange() {
    this.pageChanged.emit(this.page);
  }

  //#endregion

  //#region Disabled

  isBackDisabled(): boolean {
    return this.totalPages === 0 || this.page === 1;
  }

  isNextDisabled(): boolean {
    return this.totalPages === 0 || this.page === this.totalPages;
  }

  //#endregion
}
